// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"31d6cfe0","338":"1b2e9e03","427":"7a0655ba","564":"31d6cfe0","695":"505ddaf3","945":"890d4de3"}[chunkId] + ".chunk.css";
};